import quickFetch from 'quick-fetch';
const gateName = 'hs-resources:FLPViewEnforcement';
let cachedResult;
export const readFLPGate = () => cachedResult;
export const __TEST_ONLY_resetFLPGate = () => {
  cachedResult = undefined;
};
export const __TEST_ONLY_setFLPGate = value => {
  cachedResult = value;
};
export const checkFLPGate = () => new Promise(resolve => {
  // Bail if the auth request hasn't been made (happens before early bundle in quartz apps)
  if (!quickFetch.getLoginVerifyRequest()) {
    cachedResult = 'false';
    resolve('false');
    return;
  } else {
    let timedOut = false;

    // Fail closed if auth takes too long
    const safetyTimeout = setTimeout(() => {
      cachedResult = 'false';
      timedOut = true;
      resolve('false');
    }, 1000);

    // Wait on the auth callback
    quickFetch.afterAuth(auth => {
      if (!timedOut) {
        var _auth$portal$enabled_;
        clearTimeout(safetyTimeout);
        cachedResult = (_auth$portal$enabled_ = auth.portal.enabled_v3_gates) !== null && _auth$portal$enabled_ !== void 0 && _auth$portal$enabled_.includes(gateName) ? 'true' : 'false';
        resolve(cachedResult);
      }
    });
  }
});